import React from 'react';
import { UsersIcon } from 'lucide-react';
const SPOTS_TOTAL = 200;
const SPOTS_LEFT = 17;
export function ScarcityBar() {
  const filled = Math.round((SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100);
  return <div className="w-full rounded-2xl border border-navy-100 bg-white p-4" data-id="element-52" data-mp="2l3v34pklwc7f">
      <div className="flex items-start justify-between gap-3" data-id="element-53" data-mp="2q3hfyxwivqfp">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-navy-800 sm:text-sm" data-id="element-54" data-mp="2q1wj31mqjveo">
          <UsersIcon className="h-4 w-4 shrink-0 text-alert-600" aria-hidden="true" data-id="element-55" data-mp="2g5tjo3j9qavf" />
          Only {SPOTS_LEFT} spots left at the promotional price
        </p>
        <span className="shrink-0 rounded-full bg-alert-500/10 px-2 py-1 text-[10px] font-black uppercase tracking-wider text-alert-600" data-id="element-56" data-mp="227mvjf44fp8y">
          {filled}% taken
        </span>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-navy-100" role="progressbar" aria-valuemin={0} aria-valuemax={SPOTS_TOTAL} aria-valuenow={SPOTS_TOTAL - SPOTS_LEFT} aria-label="Promotional spots claimed" data-id="element-57" data-mp="g09lrz36kjc">
        <div className="h-full rounded-full bg-alert-500" style={{
        width: `${filled}%`
      }} data-id="element-58" data-mp="2zm2uziuf8s5r" />
      </div>
      <p className="mt-2 text-[11px] font-medium text-navy-500" data-id="element-59" data-mp="3dbwmk8xb9qj6">
        {SPOTS_TOTAL - SPOTS_LEFT} of {SPOTS_TOTAL} launch spots already claimed.
      </p>
    </div>;
}